
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { DatabaseRepositoryInterface, DatabaseUserInterface } from '@/services/Database/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'databaseRepository',
  ],
})
export default class DeleteDatabaseUserDialog extends Vue {
  @Prop() private readonly user!: DatabaseUserInterface;

  private databaseRepository!: DatabaseRepositoryInterface;
  private visible: boolean = true;

  get message(): string {
    return `Are you sure you want to delete user ${this.user.username}?`;
  }

  private async deleteUser(): Promise<void> {
    try {
      await this.databaseRepository.deleteUser(this.user.id);
      this.$successDialog.show(`User ${this.user.username} deleted successfully`);
      this.$emit('user-deleted', this.user)
      this.destroyComponent();
    } catch (e) {
      this.$errorDialog.show(e.response?.data?.message || e.message);
    }
  }

  private destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }
}
